export default __webpack_public_path__ + "static/media/watchdog-3.a687b8ba.png";